<template>
    <div class="overflow-y-auto h-screen-header" ref="albumview">
        <!-- tab栏 -->
        <div class="tabs tabs-boxed mb-2 bg-base-100 !flex">
            <!-- 移动端优化：支持横向滚动的tab栏 -->
            <div class="flex w-full mobile-tab-container">
                <div class="flex-1 flex overflow-x-auto overflow-y-hidden scrollbar-hide">
                    <div class="flex whitespace-nowrap items-center">
                        <a v-for="{ value, text } in options" :key="value"
                            :class="{ 'tab': true, 'tab-active': sortValue === value || (customRulesActive && currentCustomRule === value), 'flex-shrink-0': true }"
                            @click="handleTabClick(value)">
                            {{ $tt(text) }}
                        </a>
                        <button @click="toggleCustomSettings" class="cursor-pointer btn btn-ghost btn-sm">
                            +
                        </button>
                    </div>
                </div>
                <div class="flex justify-center items-center flex-shrink-0 ml-2">
                    <a :class="{ 'tab': true, 'tab-active': showMode === 'grid' }" @click="showMode = 'grid'">
                        <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M170.666667 85.333333a85.333333 85.333333 0 0 0-85.333334 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333333-85.333334H170.666667zM170.666667 554.666667a85.333333 85.333333 0 0 0-85.333334 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333334 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333333-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333333-85.333333H170.666667zM640 85.333333a85.333333 85.333333 0 0 0-85.333333 85.333334v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333333h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333333V170.666667a85.333333 85.333333 0 0 0-85.333334-85.333334h-213.333333zM640 554.666667a85.333333 85.333333 0 0 0-85.333333 85.333333v213.333333a85.333333 85.333333 0 0 0 85.333333 85.333334h213.333333a85.333333 85.333333 0 0 0 85.333334-85.333334v-213.333333a85.333333 85.333333 0 0 0-85.333334-85.333333h-213.333333z">
                            </path>
                        </svg>
                    </a>
                    <a :class="{ 'tab': true, 'tab-active': showMode === 'list' }" @click="showMode = 'list'">
                        <svg class="icon w-5 h-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M134.976 853.312H89.6c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32 0 27.328-20.288 48.256-46.912 48.256zM134.976 560.32H89.6C63.04 560.32 42.688 539.392 42.688 512s20.352-48.32 46.912-48.32h45.376c26.624 0 46.912 20.928 46.912 48.32s-20.288 48.32-46.912 48.32zM134.976 267.264H89.6c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h45.376c26.624 0 46.912 20.928 46.912 48.256 0 27.392-20.288 48.32-46.912 48.32zM311.744 853.312c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32 0 27.328-20.288 48.256-46.912 48.256H311.744c1.6 0 1.6 0 0 0zM311.744 560.32c-26.56 0-46.912-20.928-46.912-48.32s20.352-48.32 46.912-48.32h622.72c26.56 0 46.848 20.928 46.848 48.32s-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0zM311.744 267.264c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256h622.72c26.56 0 46.848 20.928 46.848 48.256 0 27.392-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0z">
                            </path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>

        <!-- 自定义规则设置界面 -->
        <div v-if="showCustomSettings" class="bg-base-200 rounded-lg p-4 mb-4 border-2 border-dashed border-base-300">
            <div class="flex justify-between items-center mb-3">
                <h3 class="text-lg font-semibold">{{ $tt('自定义过滤规则') }}</h3>
                <button @click="showCustomSettings = false" class="btn btn-ghost btn-sm">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                        </path>
                    </svg>
                </button>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                <!-- 排序方式 -->
                <div class="form-control">
                    <label class="label">
                        <span class="label-text">{{ $tt('排序方式') }}</span>
                    </label>
                    <select v-model="customRules.sortBy" class="select select-bordered select-sm">
                        <option value="name">{{ $tt('专辑名称') }}</option>
                        <option value="artist__name">{{ $tt('歌手名称') }}</option>
                        <option value="max_year">{{ $tt('发行年份') }}</option>
                        <option value="plays_count">{{ $tt('播放次数') }}</option>
                        <option value="created_at">{{ $tt('添加时间') }}</option>
                    </select>
                </div>

                <!-- 排序方向 -->
                <div class="form-control">
                    <label class="label">
                        <span class="label-text">{{ $tt('排序方向') }}</span>
                    </label>
                    <select v-model="customRules.sortOrder" class="select select-bordered select-sm">
                        <option value="asc">{{ $tt('升序') }}</option>
                        <option value="desc">{{ $tt('降序') }}</option>
                    </select>
                </div>

                <!-- 年份范围 -->
                <div class="form-control">
                    <label class="label">
                        <span class="label-text">{{ $tt('发行年份') }}</span>
                    </label>
                    <div class="flex space-x-2">
                        <input v-model="customRules.yearFrom" type="number" :placeholder="$tt('从')"
                            class="input input-bordered input-sm flex-1" min="1900" max="2030">
                        <input v-model="customRules.yearTo" type="number" :placeholder="$tt('到')"
                            class="input input-bordered input-sm flex-1" min="1900" max="2030">
                    </div>
                </div>

                <!-- 歌手过滤 -->
                <div class="form-control">
                    <label class="label">
                        <span class="label-text">{{ $tt('歌手名称') }}</span>
                    </label>
                    <input v-model="customRules.artist" type="text" :placeholder="$tt('输入歌手名称')"
                        class="input input-bordered input-sm">
                </div>

                <!-- 专辑名过滤 -->
                <div class="form-control">
                    <label class="label">
                        <span class="label-text">{{ $tt('专辑名称') }}</span>
                    </label>
                    <input v-model="customRules.album" type="text" :placeholder="$tt('输入专辑名称')"
                        class="input input-bordered input-sm">
                </div>

                <!-- 流派过滤 -->
                <div class="form-control">
                    <label class="label">
                        <span class="label-text">{{ $tt('音乐流派') }}</span>
                    </label>
                    <input v-model="customRules.genre" type="text" :placeholder="$tt('输入流派')"
                        class="input input-bordered input-sm">
                </div>
            </div>

            <!-- 高级选项 -->
            <div class="collapse collapse-arrow bg-base-100 mb-4">
                <input type="checkbox" class="peer" checked>
                <div class="collapse-title text-sm font-medium">
                    {{ $tt('高级选项') }}
                </div>
                <div class="collapse-content">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <!-- 播放次数过滤 -->
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text">{{ $tt('最小播放次数') }}</span>
                            </label>
                            <input v-model="customRules.minPlayCount" type="number" placeholder="0"
                                class="input input-bordered input-sm" min="0">
                        </div>

                        <!-- 专辑轨道数过滤 -->
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text">{{ $tt('最少歌曲数') }}</span>
                            </label>
                            <input v-model="customRules.minSongCount" type="number" placeholder="1"
                                class="input input-bordered input-sm" min="1">
                        </div>

                        <!-- 是否有封面 -->
                        <div class="form-control">
                            <label class="label cursor-pointer">
                                <span class="label-text">{{ $tt('只显示有封面的专辑') }}</span>
                                <input v-model="customRules.hasCover" type="checkbox" class="checkbox checkbox-sm">
                            </label>
                        </div>

                        <!-- 是否收藏 -->
                        <div class="form-control">
                            <label class="label cursor-pointer">
                                <span class="label-text">{{ $tt('只显示已收藏') }}</span>
                                <input v-model="customRules.starred" type="checkbox" class="checkbox checkbox-sm">
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 预设顺序调整 -->
            <div class="mb-4">
                <div class="collapse collapse-arrow bg-base-100">
                    <input type="checkbox" class="peer">
                    <div class="collapse-title text-sm font-medium">
                        {{ $tt('预设选项管理') }}
                    </div>
                    <div class="collapse-content">
                        <div class="space-y-4">
                            <!-- 说明文字 -->
                            <div class="alert alert-info/50">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                <span class="text-sm">{{ $tt('拖拽调整预设选项顺序，取消勾选可隐藏选项') }}</span>
                            </div>

                            <!-- 预设选项列表 -->
                            <div class="space-y-2">
                                <h4 class="font-medium text-base">{{ $tt('预设规则') }}</h4>
                                <div class="space-y-2 overflow-y-auto">
                                    <draggable 
                                        v-model="remoteOptions" 
                                        group="presets" 
                                        handle=".drag-handle"
                                        @change="savePresetSettings"
                                        class="space-y-2"
                                    >
                                        <div 
                                            v-for="(option, index) in remoteOptions" 
                                            :key="option.value"
                                            class="flex items-center p-3 bg-base-200 rounded-lg border border-base-300 hover:border-primary/50 transition-all duration-200"
                                        >
                                            <!-- 拖拽手柄 -->
                                            <div class="drag-handle cursor-move mr-3 text-base-content/60 hover:text-primary">
                                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M9 4h2v2H9V4zm0 4h2v2H9V8zm0 4h2v2H9v-2zm0 4h2v2H9v-2zm4-12h2v2h-2V4zm0 4h2v2h-2V8zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z"/>
                                                </svg>
                                            </div>

                                            <!-- 显示/隐藏开关 -->
                                            <label class="flex items-center cursor-pointer flex-1">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="option.visible" 
                                                    @change="savePresetSettings"
                                                    class="checkbox checkbox-sm checkbox-primary mr-3"
                                                >
                                                <div class="flex-1">
                                                    <span class="font-medium">{{ $tt(option.text) }}</span>
                                                    <span class="text-xs text-base-content/60 ml-2">({{ option.value }})</span>
                                                </div>
                                            </label>

                                            <!-- 顺序指示器 -->
                                            <div class="flex items-center ml-3 text-sm text-base-content/50">
                                                <span class="w-6 text-center">{{ index + 1 }}</span>
                                            </div>
                                            <!-- 自定义的删除按钮 -->
                                            <button @click="removeCustomPreset(option.value)" class="btn btn-ghost btn-xs" v-if="option.type === 'custom'">
                                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                                </svg>
                                            </button>

                                        </div>
                                    </draggable>
                                </div>
                            </div>

                            <!-- 快速操作按钮 -->
                            <div class="flex justify-between items-center pt-2 border-t border-base-300">
                                <div class="flex space-x-2">
                                    <button @click="showAllPresets" class="btn btn-ghost btn-xs">
                                        {{ $tt('全部显示') }}
                                    </button>
                                    <button @click="hideAllPresets" class="btn btn-ghost btn-xs">
                                        {{ $tt('全部隐藏') }}
                                    </button>
                                </div>
                                <div class="text-xs text-base-content/60">
                                    {{ $tt('显示 {count} 个预设', { count: remoteOptions.filter(option => option.visible).length }) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 操作按钮 -->
            <div class="flex justify-between items-center">
                <div class="flex space-x-2">
                    <button @click="showSaveRuleModal = true" class="btn btn-primary btn-sm">
                        {{ $tt('保存预设') }}
                    </button>
                    <button @click="resetCustomRules" class="btn btn-ghost btn-sm">
                        {{ $tt('重置') }}
                    </button>
                </div>
            </div>
        </div>

        <!-- 保存规则模态框 -->
        <div class="modal" :class="{ 'modal-open': showSaveRuleModal }">
            <div class="modal-box relative">
                <!-- 关闭按钮 -->
                <button @click="showSaveRuleModal = false"
                    class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                <!-- 标题 -->
                <h3 class="font-bold text-lg mb-4">{{ $tt('保存自定义规则') }}</h3>

                <!-- 表单内容 -->
                <div class="form-control mb-6">
                    <label class="label">
                        <span class="label-text">{{ $tt('规则名称') }}</span>
                    </label>
                    <input v-model="newRuleName" type="text" :placeholder="$tt('请输入规则名称')" class="input input-bordered w-full"
                        @keyup.enter="saveCustomRuleWithName" ref="ruleNameInput">
                </div>

                <!-- 操作按钮 -->
                <div class="modal-action">
                    <button @click="saveCustomRuleWithName" class="btn btn-primary btn-sm">
                        {{ $tt('保存') }}
                    </button>
                    <button @click="showSaveRuleModal = false" class="btn btn-ghost btn-sm">{{ $tt('取消') }}</button>
                </div>
            </div>
            <div class="modal-backdrop bg-black/50" @click="showSaveRuleModal = false"></div>
        </div>

        <AlbumList :items="albums" v-if="showMode === 'grid'" :small="false" />
        <AlbumItems :items="albums" v-if="showMode === 'list'" />
        <div class="flex justify-center" v-if="loading">
            <span class="loading loading-infinity loading-lg"></span>
        </div>
        <button v-if="curScrollTop > 700" @click="scrollToTop"
            class="fixed bottom-8 right-8 bg-neutral-content hover:bg-accent hover: text-accent-content text-neutral font-bold py-2 px-4 rounded-full shadow-xl transition-colors duration-300">
            <svg t="1730534469934" class="icon h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="2399" width="200" height="200">
                <path
                    d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3c-3.8 5.3-0.1 12.7 6.5 12.7h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                    p-id="2400"></path>
            </svg>
        </button>
    </div>
</template>
<script>
import AlbumList from './AlbumList'
import AlbumItems from './AlbumItems'
import { mapGetters } from "vuex";
import draggable from 'vuedraggable'

export default {
    name: 'albums',
    components: {
        AlbumList, AlbumItems, draggable
    },
    props: {},
    data() {
        return {
            albums: [],
            loading: false,
            offset: 0,
            hasMore: true,
            showMode: 'grid',
            curScrollTop: 0,
            watchSearchTerm: null,
            searchTimeout: null,
            // 自定义规则相关
            showCustomSettings: false,
            customRulesActive: false,
            customRules: {
                sortBy: 'name',
                sortOrder: 'asc',
                yearFrom: null,
                yearTo: null,
                artist: '',
                album: '',
                genre: '',
                minPlayCount: null,
                minSongCount: null,
                hasCover: false,
                starred: false
            },
            allAlbums: [], // 存储所有专辑数据用于过滤
            filteredAlbums: [], // 过滤后的专辑
            // 规则管理相关
            showSaveRuleModal: false,
            showLoadRuleModal: false,
            newRuleName: '',
            // 预设选项管理
            presetOptions: [
                { text: '最近添加', value: 'recently-added', visible: true },
                { text: '最近播放', value: 'recently-played', visible: true },
                { text: '最多播放', value: 'most-played', visible: true },
                { text: 'A-Z排序', value: 'a-z', visible: true },
                { text: '歌手排序', value: 'artist-sort', visible: true },
                { text: '缺失封面', value: 'less_cover', visible: true },
            ],
            remoteOptions: [],
            currentCustomRule: null, // 当前选中的自定义规则
        }
    },
    computed: {
        ...mapGetters(['getSearchTerm']),
        options() {
            // 确保 remoteOptions 是数组
            if (!Array.isArray(this.remoteOptions)) {
                return []
            }
            return this.remoteOptions.filter(option => option.visible)
        },
        sortValue: {
            get() {
                return this.$route.params.sort
            }
        },
    },
    mounted() {
        this.loadSavedRules()
    },
    beforeDestroy() {
        // 清理事件监听器
        document.removeEventListener('keydown', this.handleKeyDown)
        if (window.albumview) {
            window.albumview.removeEventListener('scroll', this.listenBottomOut, false)
        }
    },
    destroyed() {
        // 停止观察器
        this.stopWatching()
    },
    async created() {
        // 加载预设设置
        this.loadMore()
    },

    //当组件第一次被创建时，会先触发created,后触发activated
    //当组件被激活时，只会触发activated，不触发created
    activated() {
        this.$refs.albumview.addEventListener('scroll', this.listenBottomOut)
        window.albumview = this.$refs.albumview
        window.albumview.scrollTop = this.curScrollTop || 0
        this.startWatching()

        // 添加键盘事件监听
        document.addEventListener('keydown', this.handleKeyDown)
    },
    deactivated() {
        // 离开页面取消监听
        window.albumview.removeEventListener('scroll', this.listenBottomOut, false)
        this.stopWatching()

        // 移除键盘事件监听
        document.removeEventListener('keydown', this.handleKeyDown)
    },
    methods: {
        startWatching() {
            if (!this.watchSearchTerm) {
                this.watchSearchTerm = this.$watch('getSearchTerm', this.loadSearchTimeout);
            }
        },
        stopWatching() {
            if (this.watchSearchTerm) {
                this.watchSearchTerm()
                this.watchSearchTerm = null
            }
        },
        loadMore() {
            this.loading = true
            return this.$api.subsonic.getAlbums(this.sortValue, 50, this.offset).then(albums => {
                this.albums.push(...albums)
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch((err) => {
                if (err.message === 'Wrong username or password.') {
                    this.$myMsg.notify({
                        title: this.$tt('查询失败！'),
                        content: this.$tt('请在后台管理创建一个subsonic密码，刷新页面试试吧'),
                        type: 'error',
                        time: 5000,
                        url: '/admin/user/userprofile/'
                    })
                    this.$router.push({ name: 'login' })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: err.messagee ? err.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        loadSearchTimeout() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout)
            }
            this.searchTimeout = setTimeout(() => {
                this.searchTimeout = null
                this.loadSearch()
            }, 300)
        },
        loadSearch() {
            if (this.getSearchTerm === '') {
                this.offset = 0
                this.albums = []
                this.hasMore = true
                this.loadMore()
                return
            }
            this.loading = true
            this.offset = 0
            this.hasMore = true
            return this.$api.subsonic.searchAlbums('search', this.getSearchTerm, 30, this.offset).then(albums => {
                this.albums = albums
                this.offset += albums.length
                this.hasMore = albums.length > 0
                this.loading = false
            }).catch((err) => {
                if (err.message === 'Wrong username or password.') {
                    this.$myMsg.notify({
                        title: this.$tt('查询失败！'),
                        content: this.$tt('请在后台管理创建一个subsonic密码，刷新页面试试吧'),
                        type: 'error',
                        time: 5000,
                        url: '/admin/user/userprofile/'
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: err.messagee ? err.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        listenBottomOut() {
            if (this.hasMore && !this.loading) {
                const scrollTop = window.albumview.scrollTop
                const scrollHeight = window.albumview.scrollHeight
                const clientHeight = window.albumview.clientHeight
                this.curScrollTop = scrollTop
                if (scrollTop + clientHeight >= scrollHeight - 50) {
                    if (!this.customRulesActive) {
                        this.loadMore()
                    }
                }
            }
        },
        scrollToTop() {
            window.albumview.scrollTop = 0
        },

        // 自定义规则相关方法
        toggleCustomSettings() {
            this.showCustomSettings = !this.showCustomSettings
        },

        // 加载所有专辑数据用于过滤
        async loadAllAlbums() {
            this.loading = true
            try {
                // 分批加载所有专辑
                let allAlbums = []
                let offset = 0
                const limit = 100
                let hasMore = true

                while (hasMore) {
                    const albums = await this.$api.subsonic.getAlbums('a-z', limit, offset)
                    allAlbums.push(...albums)
                    offset += albums.length
                    hasMore = albums.length === limit
                }

                this.allAlbums = allAlbums
                this.filteredAlbums = [...allAlbums]
            } catch (err) {
                this.$myMsg.notify({
                    title: this.$tt('加载失败！'),
                    content: err.message || this.$tt('加载专辑数据失败'),
                    type: 'error',
                    time: 3000,
                })
            } finally {
                this.loading = false
            }
        },

        // 重置规则
        resetCustomRules() {
            this.customRules = {
                sortBy: 'name',
                sortOrder: 'asc',
                yearFrom: null,
                yearTo: null,
                artist: '',
                album: '',
                genre: '',
                minPlayCount: null,
                minSongCount: null,
                hasCover: false,
                starred: false
            }
        },

        // 保存自定义规则到后端
        async saveCustomRuleWithName() {
            if (this.newRuleName.trim() === '') {
                this.$myMsg.notify({
                    title: this.$tt('保存失败！'),
                    content: this.$tt('请输入规则名称'),
                    type: 'error',
                    time: 2000,
                })
                return
            }
            this.remoteOptions.push({
                    text: this.newRuleName,
                    value: this.newRuleName,
                    visible: true,
                    type: 'custom',
                    rule: { ...this.customRules }
            })

            try {
                // 保存到后端
                await this.savePresetSettings()
                this.showSaveRuleModal = false
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('保存失败！'),
                    content: error.message || this.$tt('保存规则时出现错误'),
                    type: 'error',
                    time: 3000,
                })
            }
        },

        // 从localStorage载入规则
        loadCustomRule() {
            this.loadSavedRules()
            this.showLoadRuleModal = true
        },

        // 从后端载入保存的规则列表
        async loadSavedRules() {
            try {
                // 从后端获取系统配置
                const response = await this.$api.Task.getSys({'key': 'album_tabs'})
                if (response && response.data.items.length >0) {
                    this.remoteOptions = JSON.parse(response.data.items[0].value)
                }
                if (this.remoteOptions.length === 0) {
                    this.remoteOptions = this.presetOptions
                }
                
            } catch (error) {
                console.error('加载保存的规则失败:', error)
                this.customPresetOptions = []
            }
        },

        // 获取排序字段的中文名称
        getSortText(sortBy) {
            const sortOptions = {
                'name': '专辑名称',
                'artist': '歌手名称',
                'year': '发行年份',
                'playCount': '播放次数',
                'created': '添加时间',
                'starred': '收藏时间'
            }
            return this.$tt(sortOptions[sortBy] || sortBy)
        },

        // 保存预设选项设置到后端
        async savePresetSettings() {
            try {
                // 调用后端保存接口
                await this.$api.Task.UpdateSys({
                    key: 'album_tabs',
                    value: JSON.stringify(this.remoteOptions)
                })

                this.$myMsg.notify({
                    title: this.$tt('预设选项保存成功！'),
                    content: this.$tt('预设选项已保存到服务器'),
                    type: 'success',
                    time: 2000,
                })
            } catch (error) {
                console.error('保存预设设置失败:', error)
                this.$myMsg.notify({
                    title: this.$tt('保存失败！'),
                    content: error.message || this.$tt('保存预设设置时出现错误'),
                    type: 'error',
                    time: 3000,
                })
                throw error
            }
        },

        // 显示所有预设
        async showAllPresets() {
            this.remoteOptions.forEach(p => p.visible = true)
            await this.savePresetSettings()
        },

        // 隐藏所有预设
        async hideAllPresets() {
            this.remoteOptions.forEach(p => p.visible = false)
            await this.savePresetSettings()
        },

        // 移除自定义规则预设
        async removeCustomPreset(value) {
            try {
                this.remoteOptions = this.remoteOptions.filter(p => p.value !== value)
                
                // 调用后端保存接口
                await this.$api.Task.UpdateSys({
                    key: 'album_tabs',
                    value: JSON.stringify(this.remoteOptions)
                })
                
                this.$myMsg.notify({
                    title: this.$tt('移除成功！'),
                    content: this.$tt('自定义预设 "{name}" 已移除', { name: value }),
                    type: 'success',
                    time: 2000,
                })
            } catch (error) {
                this.$myMsg.notify({
                    title: this.$tt('移除失败！'),
                    content: error.message || this.$tt('移除预设时出现错误'),
                    type: 'error',
                    time: 3000,
                })
            }
        },
        // 处理Tab点击事件
        handleTabClick(value) {
            this.$router.push({ path: '/albums/' + value })
        },

        // 键盘事件处理
        handleKeyDown(event) {
            // ESC键关闭模态框
            if (event.key === 'Escape') {
                if (this.showSaveRuleModal) {
                    this.showSaveRuleModal = false
                } else if (this.showLoadRuleModal) {
                    this.showLoadRuleModal = false
                } else if (this.showCustomSettings) {
                    this.showCustomSettings = false
                }
            }
        }
    }
}
</script>

<style scoped>
/* 移动端Tab栏优化样式 */
.mobile-tab-container {
    /* 确保容器在移动端能够正确处理溢出 */
    min-height: 40px;
}

.scrollbar-hide {
    /* 隐藏滚动条，但保持滚动功能 */
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* 移动端响应式优化 */
@media screen and (max-width: 768px) {
    .mobile-tab-container {
        /* 移动端确保tab栏不会换行 */
        flex-wrap: nowrap;
    }

    .mobile-tab-container .tab {
        /* 移动端tab项缩小间距和字体 */
        padding: 0.5rem 0.75rem;
        font-size: 0.875rem;
        white-space: nowrap;
        min-width: auto;
    }

    .mobile-tab-container .flex-shrink-0 {
        /* 确保tab项不会被压缩 */
        flex-shrink: 0;
    }
}

/* 小屏幕进一步优化 */
@media screen and (max-width: 480px) {
    .mobile-tab-container .tab {
        /* 小屏幕进一步缩小间距 */
        padding: 0.4rem 0.6rem;
        font-size: 0.8rem;
    }

    .mobile-tab-container .icon {
        /* 小屏幕适当缩小图标 */
        width: 1rem;
        height: 1rem;
    }
}
</style>
